import styled from "vue-styled-components";

export const Container = styled.div`
  margin-bottom: 20px;
`;
